// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__Nqecr","header":"Messages_header__1KUQD"};